var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isKDUContract && _vm.tender.tenderStatus.id == _vm.statuseKeys.COMPLETED)?_c('MenuItem',{staticClass:"h11-links",attrs:{"data-qa":"generate-contract","disabled":_vm.loading,"icon":"add-file","label":_vm.$t('Tenders.FormContract')},on:{"click":_vm.createContract}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }